import type { IUser } from "../../../../types/models/user.models.types";
import { usePostHttp } from "../../http.hook";

interface IResponse {
  user: IUser;
}

interface IBody {
  name: string;
  phone: string;
  visibleToBrandEnabled: boolean;
}

export function useCreateEphemeralUserAdminHttp() {
  return usePostHttp<IBody, IResponse>({
    path: "/admin/campaigns/:campaignId/ephemeral-user",
  });
}
